import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-risk-and-impects-of-accessibility-permission',
  templateUrl: './risk-and-impects-of-accessibility-permission.component.html',
  styleUrls: ['./risk-and-impects-of-accessibility-permission.component.css']
})
export class RiskAndImpectsOfAccessibilityPermissionComponent implements OnInit {

  heading = "The Risk and Impact of Accessibility Permission on Mobile Apps";
  subheading = "";
  innerWidth:number = window.innerWidth;

  constructor() { }

  ngOnInit(): void {
  }

  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
